import { useLocale } from '@react-aria/i18n';
import { useMemo } from 'react';

type ListFormatter = { format: (array: any) => string };
const defaultListFormatter = { format: (array: string[]) => array.join(', ') };
const getListFormatter: (
  locale: string,
  options?: Partial<Intl.ListFormatOptions>
) => ListFormatter = (locale: string, options: any) =>
  typeof Intl.ListFormat !== 'undefined'
    ? new Intl.ListFormat(locale, options)
    : defaultListFormatter;

export function useListFormatter(options?: Partial<Intl.ListFormatOptions>): ListFormatter {
  let { locale } = useLocale();
  return useMemo(() => getListFormatter(locale, options), [locale, options]);
}
